// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5929) return "static/chunks/5929.b928fa49c8824417.js";
	if (chunkId === 4210) return "static/chunks/4210.224e6e897a82c168.js";
	if (chunkId === 1963) return "static/chunks/1963.f7c94f449fa8f41f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"155":"eb34e2d2f1b9b10b","1197":"15991c96a6040ffd","1599":"90061b18d0ccc5db","4159":"3c65a6674f4356f0","5110":"6309f8714f043e96","7256":"490641fb0b0f4555","9837":"c1029fe7f692715f"}[chunkId] + ".js";
};